import { TickmillCompanyDto } from '../../Identity/Types/Company'

export interface LossPercentageDto {
  id: string
  percentage: number
  tickmillCompany: TickmillCompanyDto
}

export interface CreateTickmillCompanyLossPercentage {
  percentage: number
  tickmillCompanyId: number
}

export interface UpdateTickmillCompanyLossPercentage {
  id: string
  percentage: number
}

export enum LossPercentageDtoKey {
  company = 'tickmillCompany.name',
  percentage = 'percentage',
}
